"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDirectDebitAmount = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var with_customer_and_account_ids_1 = require("../../../../shared/core/utils/with-customer-and-account-ids");
var analytics_subjects_1 = require("../../analytics-subjects");
var data_1 = require("../../data");
var ui_1 = require("./ui");
exports.ChangeDirectDebitAmount = (0, with_customer_and_account_ids_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var _c, _d, _e, _f;
    var accountId = _a.accountId, customerId = _a.customerId;
    var _g = (0, data_1.useDirectDebitAmount)(accountId), error = _g.error, loading = _g.loading, data = _g.data;
    var features = (0, core_1.useFeatureContext)().features;
    var retailer = core_1.configService.getConfig().retailer;
    var kapiEnabled = retailer.region === 'AUS';
    return loading ? (react_1.default.createElement(ui_1.Loading, null)) : error && error.errorCode === 'GENERIC' ? (react_1.default.createElement(ui_1.Error, null)) : (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.AMEND_DD_AMOUNT, properties: (_b = {
                RecommendationShown: (((_c = data === null || data === void 0 ? void 0 : data.legacy) === null || _c === void 0 ? void 0 : _c.recommendedDirectDebit) ||
                    ((_d = data === null || data === void 0 ? void 0 : data.kapi) === null || _d === void 0 ? void 0 : _d.paymentRecommendation)) &&
                    !(features === null || features === void 0 ? void 0 : features.hideRecommendedDirectDebit)
                    ? true
                    : false
            },
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b) }, kapiEnabled ? (react_1.default.createElement(ui_1.ChangeDirectDebitAmountUIV2, { accountId: accountId, customerId: customerId, paymentDetails: data.kapi, apiErrorCode: error === null || error === void 0 ? void 0 : error.errorCode })) : ((_e = data === null || data === void 0 ? void 0 : data.legacy) === null || _e === void 0 ? void 0 : _e.directDebit) ? (react_1.default.createElement(ui_1.ChangeDirectDebitAmountUI, { accountId: accountId, customerId: customerId, recommendedDirectDebit: !(features === null || features === void 0 ? void 0 : features.hideRecommendedDirectDebit)
            ? (_f = data.legacy) === null || _f === void 0 ? void 0 : _f.recommendedDirectDebit
            : undefined, directDebit: data.legacy.directDebit })) : null));
}, ui_1.Loading);
